import React, { createContext, useState, useEffect } from "react";
import plus from "./assets/plus.svg";
import { pageFetchMainURL } from "./constant";

import measure from "./components/measure";
import shapes from "./components/shapes";
import portions from "./components/portions";
import edges from "./components/edges";
import x from "./assets/x.svg";
import "./context.scss";
import cx from "classnames";
import reddot from "./assets/reddot.svg";
import whitedot from "./assets/whitedot.svg";
import low from "./assets/low.svg";
import medium from "./assets/medium.svg";
import high from "./assets/high.svg";
import HoverImage from "react-hover-image";
import axios from "axios";

export const SquareContext = createContext({});

const initialState = {
  id: 0,
  img: plus,
  size: "",
  border: "",
  name: "",
};

const initialColor = "#d9d9d9";
const activeColor = "#ff262d";

const SquareContextProvider = ({ children }) => {
  const [isActive, setIsActive] = useState([]);
  const [isActive2, setIsActive2] = useState(false);
  const [isActive3, setIsActive3] = useState(false);
  const [click, setClick] = useState("false");
  const [state, setState] = useState(initialState);

  const [btnColor, setBtnColor] = useState(initialColor);
  const [btnColor2, setBtnColor2] = useState(initialColor);
  const [cartTotal, setCartTotal] = useState(0);
  const [cart, setCart] = useState([]);
  const [shape, setShape] = useState([]);
  const [unit, setUnit] = useState([]);
  const [unit2, setUnit2] = useState([]);
  const [unit3, setUnit3] = useState([]);
  const [unit4, setUnit4] = useState([]);
  const [unit5, setUnit5] = useState([]);
  const [unit6, setUnit6] = useState([]);
  const [unit7, setUnit7] = useState([]);
  const [unit8, setUnit8] = useState([]);
  const [unit9, setUnit9] = useState([]);

  const [stones, setStones] = useState([]);
  const [shapesx, setShapesx] = useState([]);
  const [edgesx, setEdgesx] = useState([]);
  const [slabSize, setSlabSize] = useState([]);
  const [stepDesc, setStepDesc] = useState([]);

  const [summary, setSummary] = useState([]);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=products`)
      .then((res) => res.json())
      .then((data) => setStones(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=shapes`)
      .then((res) => res.json())
      .then((data) => setShapesx(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=edges`)
      .then((res) => res.json())
      .then((data) => setEdgesx(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=products`)
      .then((res) => res.json())
      .then((data) => setSlabSize(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=steps`)
      .then((res) => res.json())
      .then((data) => setStepDesc(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=summary`)
      .then((res) => res.json())
      .then((data) => setSummary(data));
    // .catch(err => console.log(err.message));
  }, []);

  useEffect(() => {
    if (cart.length > 3) {
      cart.length = 3;
    }
  }, [cart]);

  useEffect(() => {
    total();
  }, [cart]);

  const total = () => {
    let totalVal = 0;
    for (let i = 0; i < cart.length; i++) {
      totalVal += cart[i].price;
    }
    setCartTotal(totalVal);
  };
  //step 1 context  ******************************and step 5****************************
  useEffect(() => {
    if (cart.length === 0) {
    }
  }, []);
  const [isAdded, setIsAdded] = useState(false);

  //.bind(this);

  const addToCart = (el) => {
    if (!cart.find(({ id }) => id === el.id)) setCart([...cart, el]);
    setBtnColor(activeColor);
  };

  const removeFromCart = (el) => {
    let hardCopy = [...cart];
    hardCopy = hardCopy.filter((cartItem) => cartItem.id !== el.id);
    setCart(hardCopy);
    if (hardCopy.length === 0) {
      setBtnColor(initialColor);
    }
  };

  // const listItems = stones.map((el) => (
  //   <div key={el.id} data-id={el.id}  className="square-col" onClick={() => addToCart(el)}>
  //     <div

  //       className="first-square"
  //       key={el.id}
  //       style={{
  //         backgroundImage: `url(${el.img})`,
  //       }}
  //     >
  //       {/* <img src={el.img} alt="" /> */}
  //     </div>
  //     <p> {`${el.title}`}</p>
  //   </div>
  // ));

  const listItems = stones.map((el) => (
    <div
      key={el.id}
      data-id={el.id}
      className="square-col"
      onClick={() => addToCart(el)}
    ></div>
  ));

  const cartItems = cart.map((el) => (
    <>
      <div
        className="square-box"
        key={el.id}
        style={{
          backgroundImage: `url(${el.img})`,
          backgroundSize: "90%",
        }}
      >
        {/* <img src={el.img} alt="" /> */}
        <img src={x} alt="" onClick={() => removeFromCart(el)} />
      </div>
      <p> {`${el.title}`}</p>
    </>
  ));

  const unitImg = cart.map((el) => <img src={el.img} alt="" />);

  const slabArea = cart.map((el) => el.slab);
  // console.log(slabArea)

  const unitName = cart.map((el) => <p>{el.title}</p>);

  const graniteType = cart.map((el) => el.category);

  // step 2 context **********************************************************
  const [act, setAct] = useState(3);
  const [oddAct, setOddAct] = useState(3);

  const addToShape = (el) => {
    if (shape.length === 0) {
      setShape([el]);
      setBtnColor2(activeColor);
    } else if (shape.find((obj) => obj.id !== el.id)) {
      setShape([el]);
      setBtnColor2(activeColor);
    } else {
      setShape([]);
      setBtnColor2(initialColor);
    }
  };

  const removeFromShape = (el) => {
    setShape([]);
    setBtnColor2(initialColor);
  };

  const removeDimensionState = () => {
    if (shape.find((obj) => obj.id === 1)) {
      setInVal3("");
      setInVal4("");
      setInVal5("");
      setInVal6("");
      setInVal7("");
      setInVal8("");
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 2)) {
      setInVal5("");
      setInVal6("");
      setInVal7("");
      setInVal8("");
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 3)) {
      setInVal7("");
      setInVal8("");
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 4)) {
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 5)) {
      setInVal5("");
      setInVal6("");
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 6)) {
      setInVal9("");
      setInVal10("");
    } else if (shape.find((obj) => obj.id === 7)) {
    } else if (shape.find((obj) => obj.id === 8)) {
      setInVal3("");
      setInVal4("");
      setInVal5("");
      setInVal6("");
      setInVal9("");
      setInVal10("");
    }
  };

  // switch(shape.find((obj) => obj.id)) {
  //   case n:

  //     break;
  //   case n:

  //     break;
  //   default:
  //     default
  // }

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const listShape = shapesx.map((el) => (
    <div
      key={el.id}
      className="single mrg mrg2"
      onClick={() => {
        addToShape(el);
      }}
      style={{ cursor: "pointer" }}
    >
      <div className="shapes-map">
        <p>{el.name}</p>
        <svg
          className="plus-step"
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="42"
          viewBox="0 0 44 42"
        >
          <g
            id="Group_1370"
            data-name="Group 1370"
            transform="translate(-1768 -632)"
          >
            <rect
              id="Rectangle_849"
              data-name="Rectangle 849"
              width="44"
              height="42"
              rx="21"
              transform="translate(1768 632)"
              stroke="none"
            />
            <g
              id="Group_1121"
              data-name="Group 1121"
              transform="translate(1782.541 653.716) rotate(-45)"
            >
              <line
                id="Line_214"
                data-name="Line 214"
                x2="15.974"
                transform="translate(0 0) rotate(45)"
                fill="none"
                strokeWidth="4"
              />
              <line
                id="Line_215"
                data-name="Line 215"
                x2="15.974"
                transform="translate(0 11.296) rotate(-45)"
                fill="none"
                strokeWidth="4"
              />
            </g>
          </g>
        </svg>
      </div>
      <div className={`mrg-img${el.id} shapes-svg`}>
        {/* <img src={el.img} alt="" /> */}

        {htmlToReactParser.parse(el.img)}
      </div>
    </div>
  ));

  const shapeItems = shape.map((el) => (
    <div className="shape-p">
      <p key={el.id}>{`${el.name}`}</p>
    </div>
  ));

  //step 5 ******************************************************************
  const dimShape = shape.map((el) => (
    <img key={el.id} className="dimi" src={el.img} alt="" />
  ));
  const [result, setResult] = useState();
  const [resultTotal, setResultTotal] = useState();
  const [resSum, setResSum] = useState(0);
  const [linearArea, setLinearArea] = useState(0);
  const [linearAreaM, setLinearAreaM] = useState(0);

  //  step 3 context *************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************

  const [checked, setChecked] = useState(false);
  const [checked2, setChecked2] = useState(false);

  const [checked3, setChecked3] = useState(false);
  const [checked4, setChecked4] = useState(false);

  const [checked5, setChecked5] = useState(false);
  const [checked6, setChecked6] = useState(false);

  const [checked7, setChecked7] = useState(false);
  const [checked8, setChecked8] = useState(false);
  const [checked9, setChecked9] = useState(false);

  const addToUnit = (el) => {
    setUnit([el]);
    // setBtnColor2(activeColor);
    if (!checked) {
      setChecked(true);
    } else {
      setChecked(false);
      setUnit([]);
    }
  };

  const addToUnit2 = (el) => {
    setUnit2([el]);
    // setBtnColor2(activeColor);
    if (!checked2) {
      setChecked2(true);
    } else {
      setChecked2(false);
      setUnit2([]);
    }
  };

  const addToUnit3 = (el) => {
    setUnit3([el]);
    // setBtnColor2(activeColor);
    if (!checked3) {
      setChecked3(true);
    } else {
      setChecked3(false);
      setUnit3([]);
    }
  };

  const addToUnit4 = (el) => {
    setUnit4([el]);
    // setBtnColor4(activeColor);
    if (!checked4) {
      setChecked4(true);
    } else {
      setChecked4(false);
      setUnit4([]);
    }
  };
  const addToUnit5 = (el) => {
    setUnit5([el]);
    // setBtnColor2(activeColor);
    if (!checked5) {
      setChecked5(true);
    } else {
      setChecked5(false);
      setUnit5([]);
    }
  };

  const addToUnit6 = (el) => {
    setUnit6([el]);
    // setBtnColor6(activeColor);
    if (!checked6) {
      setChecked6(true);
    } else {
      setChecked6(false);
      setUnit6([]);
    }
  };

  const addToUnit7 = (el) => {
    setUnit7([el]);
    // setBtnColor7(activeColor);
    if (!checked7) {
      setChecked7(true);
    } else {
      setChecked7(false);
      setUnit7([]);
    }
  };
  const addToUnit8 = (el) => {
    setUnit8([el]);
    // setBtnColor8(activeColor);
    if (!checked8) {
      setChecked8(true);
    } else {
      setChecked8(false);
      setUnit8([]);
    }
  };
  const addToUnit9 = (el) => {
    setUnit9([el]);
    // setBtnColor9(activeColor);
    if (!checked9) {
      setChecked9(true);
    } else {
      setChecked9(false);
      setUnit9([]);
    }
  };

  const removeFromUnit = (el) => {
    setShape([]);
    // setBtnColor2(initialColor);
  };

  // const listUnits = stones.map((el) => (
  //   <div className="shape-radio">
  //     <div>
  //       <label style={{ cursor: "pointer" }}>
  //         <input
  //           type="checkbox"
  //           name="inp1"
  //           id={el.id}
  //           value={el.mms}
  //           // onChange={(e) => addToUnit(e)}
  //           onChange={() => {
  //             addToUnit(el);
  //           }}
  //           checked={checked}
  //         />
  //         {Object.keys(el.thicknesses)}
  //       </label>
  //     </div>
  //     </div>
  // ))

  useEffect(() => {
    if (cart.length === 0) {
      setUnit([]);
      setUnit2([]);
      setUnit3([]);
      setUnit4([]);
      setUnit5([]);
      setUnit6([]);
      setUnit7([]);
      setUnit8([]);
      setUnit9([]);
      setChecked(false);
      setChecked2(false);
      setChecked3(false);
      setChecked4(false);
      setChecked5(false);
      setChecked6(false);
      setChecked7(false);
      setChecked8(false);
      setChecked9(false);
    } else if (cart.length === 1) {
      setUnit3([]);
      setUnit4([]);
      setUnit8([]);
      setUnit5([]);
      setUnit6([]);
      setUnit9([]);
      setChecked3(false);
      setChecked4(false);
      setChecked8(false);
      setChecked5(false);
      setChecked6(false);
      setChecked9(false);
    } else if (cart.length === 2) {
      setUnit5([]);
      setUnit6([]);
      setUnit9([]);
      setChecked5(false);
      setChecked6(false);
      setChecked9(false);
    }
  }, [cart.length]);

  // ------------------------------list unit 1-------------------------------
  const listUnits = cart.map((el) => (
    <div className="shape-radio">
      {Object.keys(el.thicknesses)[0] === "12mm" && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp1"
              id={el.id}
              value="12mm"
              // onChange={(e) => addToUnit(e)}
              onChange={() => {
                addToUnit(el);
              }}
              checked={checked}
            />
            {Object.keys(el.thicknesses)[0]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "20mm" ||
        Object.keys(el.thicknesses)[1] === "20mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              id={el.id}
              value="20mm"
              onChange={() => {
                addToUnit2(el);
              }}
              checked={checked2}
            />
            {Object.keys(el.thicknesses)[0] !== "12mm"
              ? Object.keys(el.thicknesses)[0]
              : Object.keys(el.thicknesses)[1]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "30mm" ||
        Object.keys(el.thicknesses)[1] === "30mm" ||
        Object.keys(el.thicknesses)[2] === "30mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              id={el.id}
              value="30mm"
              onChange={() => {
                addToUnit7(el);
              }}
              checked={checked7}
            />
            30mm
          </label>
        </div>
      )}
    </div>
  ));

  // ------------------------------list unit 2-------------------------------

  const listUnits2 = cart.map((el) => (
    <div key={el.id} className="shape-radio">
      {Object.keys(el.thicknesses)[0] === "12mm" && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="12mm"
              // onChange={(e) => addToUnit(e)}
              onChange={() => {
                addToUnit3(el);
              }}
              checked={checked3}
            />
            {Object.keys(el.thicknesses)[0]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "20mm" ||
        Object.keys(el.thicknesses)[1] === "20mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="20mm"
              onChange={() => {
                addToUnit4(el);
              }}
              checked={checked4}
            />
            {Object.keys(el.thicknesses)[0] !== "12mm"
              ? Object.keys(el.thicknesses)[0]
              : Object.keys(el.thicknesses)[1]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "30mm" ||
        Object.keys(el.thicknesses)[1] === "30mm" ||
        Object.keys(el.thicknesses)[2] === "30mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="30mm"
              onChange={() => {
                addToUnit8(el);
              }}
              checked={checked8}
            />
            30mm
          </label>
        </div>
      )}
    </div>
  ));
  // ------------------------------list unit 3-------------------------------
  const listUnits3 = cart.map((el) => (
    <div key={el.id} className="shape-radio">
      {Object.keys(el.thicknesses)[0] === "12mm" && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="12mm"
              // onChange={(e) => addToUnit(e)}
              onChange={() => {
                addToUnit5(el);
              }}
              checked={checked5}
            />
            {Object.keys(el.thicknesses)[0]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "20mm" ||
        Object.keys(el.thicknesses)[1] === "20mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="20mm"
              onChange={() => {
                addToUnit6(el);
              }}
              checked={checked6}
            />
            {Object.keys(el.thicknesses)[0] !== "12mm"
              ? Object.keys(el.thicknesses)[0]
              : Object.keys(el.thicknesses)[1]}
          </label>
        </div>
      )}
      {(Object.keys(el.thicknesses)[0] === "30mm" ||
        Object.keys(el.thicknesses)[1] === "30mm" ||
        Object.keys(el.thicknesses)[2] === "30mm") && (
        <div>
          <label style={{ cursor: "pointer", fontWeight: "500" }}>
            <input
              type="checkbox"
              name="inp"
              id={el.id}
              value="30mm"
              onChange={() => {
                addToUnit9(el);
              }}
              checked={checked9}
            />
            30mm
          </label>
        </div>
      )}
    </div>
  ));

  const findThick = cart.map((el) => el.thicknesses);

  const ggg = cart.map((el) => el.thicknesses);

  const shapeUnits = unit.map((el) => (
    <div className="shape-ms">
      <p key={el.id}>12mm</p>
    </div>
  ));
  const shapeUnits2 = unit2.map((el) => (
    <div className="shape-mb">
      <p key={el.id}>20mm</p>
    </div>
  ));

  const shapeUnits3 = unit3.map((el) => (
    <div className="shape-ms">
      <p key={el.id}>12mm</p>
    </div>
  ));
  const shapeUnits4 = unit4.map((el) => (
    <div className="shape-mb">
      <p key={el.id}>20mm</p>
    </div>
  ));
  const shapeUnits5 = unit5.map((el) => (
    <div className="shape-ms">
      <p key={el.id}>12mm</p>
    </div>
  ));
  const shapeUnits6 = unit6.map((el) => (
    <div className="shape-mb">
      <p key={el.id}>20mm</p>
    </div>
  ));
  const shapeUnits7 = unit7.map((el) => (
    <div className="shape-xl">
      <p key={el.id}>30mm</p>
    </div>
  ));
  const shapeUnits8 = unit8.map((el) => (
    <div className="shape-xl">
      <p key={el.id}>30mm</p>
    </div>
  ));
  const shapeUnits9 = unit9.map((el) => (
    <div className="shape-xl">
      <p key={el.id}>30mm</p>
    </div>
  ));

  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************
  // ************************************************************************************************************

  // step 4 context **************************************************************

  const [checkedStep4, setCheckedStep4] = useState(false);
  const [portion, setPortion] = useState([]);
  const [checkit, setCheckit] = useState("");

  const addToPortion = (el) => {
    setPortion([el]);
  };
  const removeFromPortion = (el) => {
    setPortion([]);
  };

  // const handleCheck = (e) => {
  //   setCheckit((checkit) => [...checkit, e.taget.id]);
  // };

  const listPortion = portions.map((el) => (
    <div key={el.id}>
      <input
        type="radio"
        name="portion"
        value={el.name}
        id={el.id}
        onClick={() => {
          addToPortion(el);
        }}
        onChange={(el) => setCheckit(el.target.id)}
        // checked={ checkit === "3"  ? true : false }
        checked={portion[0] !== undefined && el.id === portion[0].id}
      />
      <label
        htmlFor={el.id}
        style={{ cursor: "pointer", fontWeight: "500" }}
      >{`${el.name} ${el.subName}`}</label>
    </div>
  ));

  const shapePortion = portion.map((el) => (
    <div key={el.id}>
      <p className="first-measure">{`${el.name}`}</p>
      <p className="second-measure">{`${el.subName}`}</p>
    </div>
  ));

  const cmMM = portion.map((el) => <p key={el.id}>{el.disp}</p>);

  const getEle = portion.map((el) => <span key={el.id}>{el.ele}</span>);

  // step 6 context ***************************************************************

  const [edge, setEdge] = useState([]);

  const addToEdge = (el) => {
    if (edge.length === 0) {
      setEdge([el]);
    } else if (edge.find((obj) => obj.id !== el.id)) {
      setEdge([el]);
    } else {
      setEdge([]);
    }
  };

  const removeFromEdge = (el) => {
    setEdge([]);
    // setBtnColor2(initialColor);
  };

  const listEdge = edgesx.map((el) => (
    <div
      key={el.id}
      className=" mrg3  sv"
      onClick={() => {
        addToEdge(el);
      }}
      style={{ cursor: "pointer" }}
    >
      <div key={`${el.id}a`} className="inside">
        <div key={`${el.id}b`} className="head-step6">
          <p>{el.name}</p>
          {/* <img
            className="plus-step"
            src={edge.find((obj) => obj.id === el.id) ? reddot : whitedot}
            alt="plus"

          // edge.length === 0 ? addToEdge(el) : setEdge([])
          // setIsActive(el);
          /> */}
          <svg
            className="plus-step"
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="42"
            viewBox="0 0 44 42"
          >
            <g
              id="Group_1370"
              data-name="Group 1370"
              transform="translate(-1768 -632)"
            >
              <rect
                id="Rectangle_849"
                data-name="Rectangle 849"
                width="44"
                height="42"
                rx="21"
                transform="translate(1768 632)"
                stroke="none"
              />
              <g
                id="Group_1121"
                data-name="Group 1121"
                transform="translate(1782.541 653.716) rotate(-45)"
              >
                <line
                  id="Line_214"
                  data-name="Line 214"
                  x2="15.974"
                  transform="translate(0 0) rotate(45)"
                  fill="none"
                  strokeWidth="4"
                />
                <line
                  id="Line_215"
                  data-name="Line 215"
                  x2="15.974"
                  transform="translate(0 11.296) rotate(-45)"
                  fill="none"
                  strokeWidth="4"
                />
              </g>
            </g>
          </svg>
        </div>
        {/* <div className="img-step6">{htmlToReactParser.parse(el.img)}</div> */}
        <div className="img-step6">
          <img src={el.img} alt={el.name} />
        </div>
        <div className="img-step6-hover">
          <img src={el.hover} alt={el.name} />
        </div>
        {/* <div className="img-step6"><HoverImage src={el.img} hoverSrc={el.hover} alt={el.name} /></div> */}
      </div>
      <div className="inside-expense">
        <p>Level of Expense:</p>
        <img
          className="step6-img"
          src={
            (el.lvl === "low" && low) ||
            (el.lvl === "medium" && medium) ||
            (el.lvl === "high" && high)
          }
          alt="low"
        />
      </div>
    </div>
  ));

  const shapeEdge = edge.map((el) => (
    <div className="shape-p">
      <div className="edge-p" key={el.id}>{`${el.name}`}</div>
      <div className="first-edge-p">{shapeUnits[0]}</div>
      <div className="second-edge-p">{shapeUnits2[0]}</div>
      <div className="second-edge-p">{shapeUnits7[0]}</div>
    </div>
  ));

  const shapeEdge2 = edge.map((el) => (
    <div className="shape-p">
      <div className="edge-p" key={el.id}>{`${el.name}`}</div>
      <div className="first-edge-p">{shapeUnits3[0]}</div>
      <div className="second-edge-p">{shapeUnits4[0]}</div>
      <div className="second-edge-p">{shapeUnits8[0]}</div>
    </div>
  ));
  const shapeEdge3 = edge.map((el) => (
    <div className="shape-p">
      <div className="edge-p" key={el.id}>{`${el.name}`}</div>
      <div className="first-edge-p">{shapeUnits5[0]}</div>
      <div className="second-edge-p">{shapeUnits6[0]}</div>
      <div className="second-edge-p">{shapeUnits9[0]}</div>
    </div>
  ));
  const edgeName = edge.map((el) => (
    <p className="edge-p" key={el.id}>{`${el.name}`}</p>
  ));

  const edgeCash = edge.map((el) => {
    <span key={el.id}>{el.price}</span>;
  });

  const edgeid = edge.map((el) => el.id);

  // step 5 shape 1 context ***********************************************************************************************
  const [inVal, setInVal] = useState(0);
  const [inVal2, setInVal2] = useState(0);

  const [inVal3, setInVal3] = useState(0);
  const [inVal4, setInVal4] = useState(0);

  const [inVal5, setInVal5] = useState(0);
  const [inVal6, setInVal6] = useState(0);

  const [inVal7, setInVal7] = useState(0);
  const [inVal8, setInVal8] = useState(0);

  const [inVal9, setInVal9] = useState(0);
  const [inVal10, setInVal10] = useState(0);

  const rxlive = /^[+-]?\d*(?:[.,]\d*)?$/;

  const measureId = portion.find((el) => el);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleNumber = (evt, set) => {
    const tx = parseFloat(evt.target.value);

    const d = evt.target.value;

    const parsed = parseFloat(evt.target.value);

    if (parsed > 0 || parsed === 0) {
      if (measureId.id === 1) {
        set(Math.min(Math.max(parsed, 100), 9999));
        evt.target.value = Math.min(Math.max(parsed, 100), 9999);
      } else if (measureId.id === 2) {
        set(Math.min(Math.max(parsed, 10.0), 999.99));
        evt.target.value = Math.min(Math.max(parsed, 10.0), 999.99);
      } else if (measureId.id === 3) {
        set(Math.min(Math.max(parsed, 0.1), 9.99));
        evt.target.value = Math.min(Math.max(parsed, 0.0), 9.99);
      } else if (measureId.id === 4) {
        set(Math.min(Math.max(parsed, 10.0), 999.99));
        evt.target.value = Math.min(Math.max(parsed, 10.0), 999.99);
      }
    }

    // console.log(limitNumberWithinRange(d ))

    // set(limitNumberWithinRange(d))

    // set(Math.min(tx !== 0 ? tx : 0, 100))

    // if(t1 <= 100 ){
    //    set(Math.max(evt.target.value))
    // }else if(t1 >= 100 ){
    //    set(t1)
    // }

    // if (rxlive.test(evt.target.value)) {
    //   set(evt.target.value.replace(/,/g, '.'));
    // }
    // console.log(evt.target.value)
  };

  function thousands_separators(num) {
    const num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  // function handleNumber(evt, set) {
  //   const val = evt.target.value
  //   const max = 1000
  //   const maxLength = max.toString().length-1
  //   const newVal = val < max ? val : parseInt(val.toString().substring(0, maxLength))
  //   set(newVal)
  // }

  // step 7--------------------------------------------------------------------------------------------------------------
  const [stater, setStater] = useState("0");
  const [cuts, setCuts] = useState("0");
  const [cuts2, setCuts2] = useState("0");
  const [jum, setJum] = useState(1);

  const [tap, setTap] = useState("0");
  const [pop, setPop] = useState("NO");
  const [splash, setSplash] = useState("NO");
  const [upst, setUpst] = useState("NO");
  const [recessed, setRecessed] = useState("NO");

  const [grooves, setGrooves] = useState("NO");
  const [overSink, setOverSink] = useState("NO");
  const [underSink, setUnderSink] = useState("NO");
  const [hob, setHob] = useState("NO");
  const [led, setLed] = useState("NO");

  //step 4 -------------------------------------------------------------------------------------------------------------

  //model -----------------------------------------

  //model -----------------------------------------
  // ----------------------------step 9 --------------------------------------------------------------
  const [slabQuartz, setSlabQuartz] = useState(0);
  const [slabGranite, setSlabGranite] = useState(0);
  const [slabCeramic, setSlabCeramic] = useState(0);
  const [totalPrice12a, setTotalPrice12a] = useState(0);
  const [totalPrice12b, setTotalPrice12b] = useState(0);
  const [totalPrice12c, setTotalPrice12c] = useState(0);
  const [totalPrice20a, setTotalPrice20a] = useState(0);
  const [totalPrice20b, setTotalPrice20b] = useState(0);
  const [totalPrice20c, setTotalPrice20c] = useState(0);
  const [totalPrice30a, setTotalPrice30a] = useState(0);
  const [totalPrice30b, setTotalPrice30b] = useState(0);
  const [totalPrice30c, setTotalPrice30c] = useState(0);
  const [edgePrice, setEdgePrice] = useState(0);

  // useEffect(() => {
  //   if (edge.find((obj) => obj.id === 1)) {
  //     setEdgePrice(edgesx[0].price);
  //   } else if (edge.find((obj) => obj.id === 2)) {
  //     setEdgePrice(edgesx[1].price);
  //   } else if (edge.find((obj) => obj.id === 3)) {
  //     setEdgePrice(edgesx[2].price);
  //   } else if (edge.find((obj) => obj.id === 4)) {
  //     setEdgePrice(edgesx[3].price);
  //   } else if (edge.find((obj) => obj.id === 5)) {
  //     setEdgePrice(edgesx[4].price);
  //   }else if (edge.find((obj) => obj.id === 6)) {
  //     setEdgePrice(edgesx[5].price);
  //   }
  // }, [edge, edgesx, setEdgePrice]);

  useEffect(() => {
    if (
      edge.find((obj) => {
        return setEdgePrice(edgesx[obj.id - 1].price);
      })
    ) {
    }
  }, [edge, edgesx, setEdgePrice]);

  // -----------------------------------------------------------------------------------------------------------------
  const [colorArrow, setColorArrow] = useState("");

  const [nameForm, setNameForm] = useState("");
  const [surnameForm, setSurnameForm] = useState("");
  const [teleForm, setTeleForm] = useState("");
  const [mailForm, setMailForm] = useState("");
  const [addressForm, setAddressForm] = useState("");
  const [additionalForm, setAdditionalForm] = useState("");

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const [country, setCountry] = useState("");

  const [isShowed, setIsShowed] = useState(false);
  const [isShowed2, setIsShowed2] = useState(false);
  const [isShowed3, setIsShowed3] = useState(false);

  // -----------------------------------------------%%%%**********DETAILS********%%%%%%-------------------------------------
  // -----------------------------------------------rounded corners----------------------------------------------------------
  const [imght, setImght] = useState([]);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=details`)
      .then((res) => res.json())
      .then((data) => setImght(data));
    // .catch(err => console.log(err.message));
  }, []);

  const [sidePan, setSidePan] = useState([]);
  // const [sidePanelState, setSidePanelState] = useState()

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=details`)
      .then((res) => res.json())
      .then((data) => setSidePan(data));
    // .catch(err => console.log(err.message));
  }, []);

  const details = sidePan.map((el) => el);

  const corner = details[0] !== undefined && details[0]["numbers"];
  const cornerPrice = details[0] !== undefined && details[0]["price"];

  const sideArr = [];
  let i = 0;
  for (i; i <= parseInt(corner); i++) {
    sideArr.push(i);
  }

  const handleChange = (event) => {
    //rounded corners
    setStater(event.target.id);
  };

  const cornerInput = sideArr.map((el) => (
    <div key={`${el}side`} className="int">
      <input
        type="radio"
        id={`${el}`}
        onChange={handleChange}
        name="corners"
        checked={stater === `${el}` ? true : false}
      />
      <label htmlFor={`${el}`}>{el}</label>
    </div>
  ));

  // -----------------------------------------------overmounted----------------------------------------------------------
  const overPrice = details[1] !== undefined && details[1]["price"];

  // -----------------------------------------------undermounted----------------------------------------------------------
  const underPrice = details[2] !== undefined && details[2]["price"];
  // -----------------------------------------------undermounted----------------------------------------------------------
  const drainPrice = details[3] !== undefined && details[3]["price"];
  // -----------------------------------------------recessed area----------------------------------------------------------
  const recessedPrice = details[4] !== undefined && details[4]["price"];
  // -----------------------------------------------tap hole----------------------------------------------------------

  const handleTap = (e) => setTap(e.target.value);

  const tapNum = details[5] !== undefined && details[5]["numbers"];
  const tapPrice = details[5] !== undefined && details[5]["price"];

  const tapArr = [];
  let j = 0;

  for (j; j <= parseInt(tapNum); j++) {
    tapArr.push(j);
  }

  const tapInput = tapArr.map((el) => (
    <div key={`${el}tap`} className="int">
      <input
        type="radio"
        id={`${el}d`}
        value={`${el}`}
        name="tap"
        onChange={handleTap}
        checked={tap === `${el}` ? true : false}
      />
      <label htmlFor={`${el}d`}>{el}</label>
      <span className="checkmark"></span>
    </div>
  ));

  // -----------------------------------------------side- panels----------------------------------------------------------
  const handleCuts = (e) => setCuts(e.target.value); //side panels

  const handleJum = (e) => setJum(parseInt(e.target.value));

  const sideNum = details[6] !== undefined && details[6]["numbers"];

  const jumNor = details[6] !== undefined && details[6]["types"];

  const sidePanelArr = [];
  let k = 0;
  for (k; k <= parseInt(sideNum); k++) {
    sidePanelArr.push(k);
  }

  const sideInput = sidePanelArr.map((el) => (
    <div key={`${el}sidepan`} className="int">
      <input
        type="radio"
        id={`${el}b`}
        value={`${el}`}
        name="cuts"
        onChange={handleCuts}
        checked={cuts === `${el}` ? true : false}
      />
      <label htmlFor={`${el}b`}>{el}</label>
      <span className="checkmark"></span>
    </div>
  ));

  const jumQuan = [];
  let m = 0;
  for (m; m <= 2; m++) {
    jumQuan.push(m);
  }

  // console.log(jumNor[0]["price"])

  const sideJum =
    details[6] &&
    jumNor.map((el) => {
      // console.log(typeof el.id)

      return (
        <div key={el.id} className="intJum">
          <input
            type="radio"
            id={`${el.id}x`}
            value={el.id}
            name="jum"
            onChange={handleJum}
            checked={jum === el.id ? true : false}
          />
          <label
            htmlFor={`${el.id}x`}
          >{`${el.name} ${el.height}${el.unit} x ${el.width}${el.unit}`}</label>
          <span className="checkmark"></span>
        </div>
      );
    });

  // const norArea =
  //   details[6] &&
  //   (parseFloat(jumNor[0]["height"]) * parseFloat(jumNor[0]["width"])) / 10000;
  // const jumArea =
  //   details[6] &&
  //   (parseFloat(jumNor[2]["height"]) * parseFloat(jumNor[2]["width"])) / 10000;
  // const mediumArea =
  //   details[6] &&
  //   (parseFloat(jumNor[1]["height"]) * parseFloat(jumNor[1]["width"])) / 10000;
  const sideName =
    details[6] !== undefined && details[6]["types"][jum - 1].name;
  const norArea =
    details[6] !== undefined &&
    (parseFloat(jumNor[jum - 1].height) * parseFloat(jumNor[jum - 1].width)) /
      10000;
  const sidePrice =
    details[6] !== undefined && details[6]["types"][jum - 1].price;

  // -----------------------------------------------Windowsills----------------------------------------------------------
  const handleCuts2 = (e) => setCuts2(e.target.value); // windowsills

  const winPrice = details[7] !== undefined && details[7]["price"];
  const winNum = details[7] !== undefined && details[7]["numbers"];

  const winArr = [];
  let l = 0;
  for (l; l <= parseInt(winNum); l++) {
    winArr.push(l);
  }

  const winInput = winArr.map((el) => (
    <div key={`${el}win`} className="int">
      <input
        type="radio"
        id={`${el}c`}
        value={`${el}`}
        name="cuts2"
        onChange={handleCuts2}
        checked={cuts2 === `${el}` ? true : false}
      />
      <label htmlFor={`${el}c`}>{el}</label>
      <span className="checkmark"></span>
    </div>
  ));
  const windowArea =
    details[7] &&
    (parseFloat(details[7]["height"]) * parseFloat(details[7]["width"])) /
      10000;

  // -----------------------------------------------hob cut-out----------------------------------------------------------
  const hobPrice = details[8] !== undefined && details[8]["price"];
  // -----------------------------------------------pop out socket----------------------------------------------------------
  const popPrice = details[9] !== undefined && details[9]["price"];

  // -----------------------------------------------splashback----------------------------------------------------------
  const splashPrice = details[10] !== undefined && details[10]["price"];
  const splashArea =
    details[10] &&
    (parseFloat(details[10]["height"]) * parseFloat(details[10]["width"])) /
      10000;

  // -----------------------------------------------upstands---------------------------------------------------------

  const upstandPrice = details[11] !== undefined && details[11]["price"];
  const upstandArea =
    details[11] !== undefined &&
    (parseFloat(details[11]["height"]) / 100) * (linearAreaM - resSum);

  // -----------------------------------------------led grooves-------------------------------------------------
  const groovesPrice = details[12] !== undefined && details[12]["price"];

  //-------------------------------------------------counties------------------------------------------------
  const [counties, setCounties] = useState([]);
  const [countyId, setCountyId] = useState("");

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=counties`)
      .then((res) => res.json())
      .then((data) => setCounties(data));
    // .catch(err => console.log(err.message));
  }, []);

  const countiesNames = counties.map((el) => el.name);

  //-----------------------------------------------------POST-------------------------------------------------
  const [postIt, setPostIt] = useState([]);

  // console.log(portion[0] !== undefined && portion[0].name)
  const unity2 = shapeUnits3.length + shapeUnits4.length + shapeUnits8.length;
  const unity3 = shapeUnits5.length + shapeUnits6.length + shapeUnits9.length;

  //  const wewe = Object.keys(cart[0]['thicknesses'])

  //   console.log(typeof wewe)

  // console.log(jumNor)

  return (
    <SquareContext.Provider
      value={{
        sideName,
        summary,
        unity2,
        unity3,
        isAdded,
        imght,
        stepDesc,
        maxLengthCheck,
        measureId,
        edgeid,
        additionalForm,
        setAdditionalForm,
        addressForm,
        setAddressForm,
        surnameForm,
        setSurnameForm,
        day,
        setDay,
        month,
        setMonth,
        year,
        setYear,
        countyId,
        setCountyId,
        counties,
        countiesNames,
        upstandArea,
        groovesPrice,
        upstandPrice,
        linearAreaM,
        setLinearAreaM,
        linearArea,
        setLinearArea,
        splashPrice,
        splashArea,
        windowArea,
        norArea,
        // jumArea,
        jumNor,
        winPrice,
        winInput,
        sideJum,
        sidePrice,
        sideInput,
        popPrice,
        hobPrice,
        tapInput,
        tapPrice,
        recessedPrice,
        drainPrice,
        underPrice,
        overPrice,
        cornerInput,
        corner,
        cornerPrice,
        slabArea,
        isShowed,
        setIsShowed,
        isShowed2,
        setIsShowed2,
        isShowed3,
        setIsShowed3,
        country,
        setCountry,
        nameForm,
        setNameForm,
        teleForm,
        setTeleForm,
        mailForm,
        setMailForm,
        colorArrow,
        setColorArrow,
        slabQuartz,
        setSlabQuartz,
        slabGranite,
        setSlabGranite,
        slabCeramic,
        setSlabCeramic,
        totalPrice12a,
        setTotalPrice12a,
        totalPrice12b,
        setTotalPrice12b,
        totalPrice12c,
        setTotalPrice12c,

        totalPrice30a,
        setTotalPrice30a,
        totalPrice30b,
        setTotalPrice30b,
        totalPrice30c,
        setTotalPrice30c,
        totalPrice20a,
        setTotalPrice20a,
        totalPrice20b,
        setTotalPrice20b,
        totalPrice20c,
        setTotalPrice20c,
        findThick,
        edgePrice,
        setEdgePrice,
        edgeCash,
        recessed,
        setRecessed,
        edgePrice,
        listItems,
        cartItems,
        listShape,
        shapeItems,
        shapeUnits,
        shapeUnits2,
        shapeUnits3,
        shapeUnits4,
        shapeUnits5,
        shapeUnits6,
        shapeUnits7,
        shapeUnits8,
        shapeUnits9,
        removeFromShape,
        listPortion,
        shapePortion,
        listEdge,
        shapeEdge,
        shapeEdge2,
        shapeEdge3,
        edge,
        cmMM,
        checkedStep4,
        unitImg,
        unitName,
        shape,
        setShape,
        dimShape,
        listUnits,
        listUnits2,
        listUnits3,
        btnColor2,
        btnColor,
        setBtnColor,
        cart,
        getEle,
        initialState,
        isActive,
        isActive2,
        isActive3,
        setIsActive,
        setIsActive2,
        setIsActive3,
        click,
        setClick,
        state,
        setState,
        portion,
        // inval------------
        inVal,
        inVal2,
        setInVal,
        setInVal2,
        inVal3,
        setInVal3,
        inVal4,
        setInVal4,
        inVal5,
        setInVal5,
        inVal6,
        setInVal6,
        inVal7,
        setInVal7,
        inVal8,
        setInVal8,
        inVal9,
        setInVal9,
        inVal10,
        setInVal10,
        result,
        setResult,
        setResultTotal,
        resSum,
        setResSum,
        // -------------------
        resultTotal,
        edgeName,
        stater,
        setStater,
        cuts,
        setCuts,
        cuts2,
        setCuts2,
        jum,
        setJum,
        grooves,
        setGrooves,
        hob,
        setHob,
        overSink,
        setOverSink,
        underSink,
        setUnderSink,
        pop,
        setPop,
        splash,
        setSplash,
        upst,
        setUpst,
        tap,
        setTap,
        led,
        setLed,
        removeDimensionState,
        activeColor,
        initialColor,
        graniteType,
        rxlive,
        handleNumber,
        //----------------checked---------------
        checked,
        checked2,
        checked3,
        checked4,
        checked5,
        checked6,
        checked7,
        checked8,
        checked9,
        thousands_separators,
        // mediumArea,
        edgesx,
      }}
    >
      {children}
    </SquareContext.Provider>
  );
};

export default SquareContextProvider;

// function handleClick(id) {
//   granity.map((image) =>
//     setState({
//       id: image.id,
//       img: image.img,
//       size: "90%",
//       border: "2px dashed red",
//       width: "7.5em",
//       height: "7.5em",
//       name: image.name,
//     })
//   );

// }
// const [click, setClick] = useState("false");
// const [state, setState] = useState({
//   img: plus,
// });

// function handleClick() {
//   setState({
//     img: gran,
//     size: "90%",
//     border: "2px dashed red",
//     width: "9em",
//     height: "9em",
//     name: `${props.name}`,
//   });
//   setClick(true);
// }

// function handleBack() {
//   setState({ img: plus });
//   setClick(false);
// }

{
  /* <label class="switch">
  <input class="switch-input" type="checkbox" />
  <span class="switch-label" data-on="Yes" data-off="No"></span>
  <span class="switch-handle"></span>
</label> */
}

// autocomplete="off"

// split slice example

// var str = "90x100"

// var arr = str.split(/x/).slice(0);

// var first = arr[0];
// var second = arr[1];

// alert(first + ' ' + second);
